import React from 'react';
import cn from 'classnames';
import styles from './SortButton.module.scss';

const SortButton = ({ btnClassName, onClick }) => {
  return (
    <button onClick={onClick} className={cn(styles.sortButton, btnClassName)}>
      <svg
        width="12"
        height="14"
        viewBox="0 0 12 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={styles.sortIcon}
      >
        <path
          d="M9.1111 10.8967V5.44444H7.55554V10.8967H5.22221L8.33332 14L11.4444 10.8967H9.1111V10.8967ZM3.66665 0L0.555542 3.10333H2.88888V8.55556H4.44443V3.10333H6.77776L3.66665 0Z"
          fill="#624AFA"
        />
      </svg>
    </button>
  );
};

export default SortButton;
